import { ProtectedJsonAPI } from './ProtectedJsonAPI'

export const Notifications = ProtectedJsonAPI.extend(
  '/notifications',
  {
    index:   endpoint => endpoint,
    create:  endpoint => endpoint.method('post'),
    update:  endpoint => endpoint.method('put').path(({id}) => id),
    destroy: endpoint => endpoint.method('delete').path(({id}) => id),
    show:    endpoint => endpoint.path(({id}) => id),
    cancel:  endpoint => endpoint.method('post').path('/cancel'),
    enqueue: endpoint => endpoint.method('post').path('/enqueue'),
  }
)